import { render, staticRenderFns } from "./Elearning.vue?vue&type=template&id=ac72b0d8&"
import script from "./Elearning.vue?vue&type=script&lang=js&"
export * from "./Elearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports